import { useSnackbar } from "notistack";
import React, { useState } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import RowButtons from "../../../../../utility/RowButtons";
import { CustomInput } from "../../../../components/customInput/CustomInput";
import { BlackClear } from "../../../../resources/assetsManager";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../../resources/colorsManager";

function UpdateUpiModal({ onClose, onClickConfirm }) {
  const { width, height } = ResizeListener();
  const [virtualId, setVirtualId] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
    minWidth: 280,
    maxWidth: 450,
    marginRight: 20,
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 40px",
        backgroundColor: WHITE_COLOR,
        minWidth: 300,
        borderRadius: 20,
        width: "100%",
        height: "100%",
        alignItems: "center",
        maxHeight: height * 0.5,
        paddingBottom: 30,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: 0,
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Enter your UPI ID
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          margin: "15px 0px 10px 0px",
        }}
      >
        <p
          style={{
            padding: 0,
            margin: 0,
            fontSize: 14,
            fontWeight: "500",
          }}
        >
          Please enter your UPI ID
        </p>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          margin: 0,
          backgroundColor: LIGHT_GREY_BG_MODAL,
          margin: 0,
          height: 40,
          borderRadius: 5,
          marginBottom: 10,
          width: "100%",
        }}
      >
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
            padding: "0px 10px",
          }}
        >
          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
              letterSpacing: 1.2,
            }}
          >
            191203001
          </p>
        </div> */}
        <CustomInput
          value={virtualId}
          onChange={(val) => {
            setVirtualId(val);
          }}
          type="input"
          validator="number"
          inputStyles={{
            ...inputStyle,
            backgroundColor: WHITE_COLOR,
            border: "none",
            margin: 0,
            padding: "10px 10px",
            height: 38,
            margin: "0px 5px",
            fontSize: 13,
            borderRadius: 3,
            minWidth: 100,
            width: "100%",
          }}
          placeholder="upto 10 digits"
          className="input-1"
          maxLength={10}
          //   disabled={!disableBeforeVID}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
            padding: "0px 10px",
          }}
        >
          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
              letterSpacing: 1.2,
            }}
          >
            @yesbankltd
          </p>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          margin: "10px 0px",
        }}
      >
        <RowButtons
          onClick1={() => {
            onClose();
          }}
          onClick2={() => {
            // dispatch(addAccountsAction(accountFromRedux));

            if (virtualId.length > 1) {
              onClickConfirm(virtualId);
            } else {
              enqueueSnackbar("Please enter 10 digits Virtual ID", {
                variant: "error",
              });
            }
          }}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            minWidth: 240,
          }}
          buttonStyle1={{
            width: "48%",
            border: "1px solid dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          textStyles1={{
            color: "dodgerblue",
          }}
          buttonStyle2={{
            width: "48%",
            backgroundColor: "dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          buttonTitle2="Confirm"
        />
      </div>
    </div>
  );
}

export default UpdateUpiModal;
